module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-78.6b72966f.svg";